/* eslint-disable react/no-danger */
import { ReactElement } from 'react';
import Modal from 'react-modal';

import styles from './Modal.module.scss';

interface iProps {
  show: boolean;
  title: ReactElement | string;
  content: string | ReactElement;
  contentClass?: string;
  close: () => void;
}

// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#root');

const VFModal = ({ show, title, content, close, contentClass = '' }: iProps): ReactElement => {
  if (!show) {
    return <></>;
  }

  const rendercontent = (): ReactElement => {
    if (typeof content === 'string') {
      return <div className={styles.body} dangerouslySetInnerHTML={{ __html: content }} />;
    }
    return <div className={styles.body}>{content}</div>;
  };

  return (
    <>
      <Modal isOpen={show} overlayClassName={styles.overlay} className={styles.myModal} onRequestClose={close} contentLabel="Title Model" shouldCloseOnOverlayClick>
        <div className={`${styles.content} ${contentClass}`}>
          <div className={styles.heading}>
            <div className={typeof title === 'string' ? styles.title : ''}>{title}</div>
            <div className={styles.close}>
              <button
                className={styles.closeButton}
                type="button"
                onClick={(): void => {
                  close();
                }}>
                Close X
              </button>
            </div>
          </div>
          {rendercontent()}
        </div>
      </Modal>
    </>
  );
};

export default VFModal;
